import React, { Component } from 'react';
import LayoutHeader from '../Inc/Header';
import AlumniNavigation from '../Inc/AlumniNavigation';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Checkbox, Dropdown, Row, Col, Empty, Divider, Menu, Icon, Spin } from 'antd';
import { compose } from 'recompose';
import Skeleton from 'react-loading-skeleton';
import Iframe from '../HOC/iframe';
import { history } from '../../container/History'
import Truncate from 'react-truncate';
import moment from 'moment'
import { DownOutlined } from '@ant-design/icons';

const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class MyCommunicationPreference extends Component {

    constructor(props) {
        super(props)
        this.state = {
            ...props,
            communication: false,
            communicationID: 0
        }
    }

    componentDidMount = () => {
        let loggedinUser = JSON.parse(localStorage.getItem('user'))
        let personGUID = loggedinUser.personGuid;
        this.props.actions.getComPrefer(personGUID)
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.com_pre !== nextProps.com_pre) {
            this.renderComPrefer(nextProps.com_pre)
        }
    }

    renderComPrefer = (data) => {
        if (data) {
            let hasRecord = false
            let communicationPre = data
            var filteredCom = communicationPre.filter(function (data) {
                return data.topicId == 3;
            });
            if(filteredCom.length != 0) {
                hasRecord = true
                this.setState({ communicationID: hasRecord ? filteredCom[0].id : 0, communication: filteredCom[0].optOutFlag });
            } else {
              hasRecord = false  
            } 
        }
    }

    updatecommunication = (e) => {
        this.setState({ communication: true });
        this.props.actions.updateComPrefer(e.target.checked, this.state.communicationID);
      }

    render() {
        return (
            <div>
                {this.props.com_pre_loading &&
                    <Row> <Col span={24} > <Spin indicator={LoadingIcon} className="min-height-100 loading-state" tip="Loading Communications..." /> </Col> </Row>
                }
                {this.props.com_pre && <Row className='widget-content-section' type="flex" justify="start" align="top">
                    <Col span={1}>
                        <Checkbox checked={this.state.communication} onChange={this.updatecommunication} value="Yes"></Checkbox>
                    </Col>
                    <Col className='m-l-5' span={22}>
                        I would like to receive digital Alumni communications from the Scouting America.
                </Col>
                </Row>}
            </div>

        )
    }
}

function mapStateToProps(state) {
    return {
        com_pre_loading: state.getComPreferReducer.loading,
        com_pre: state.getComPreferReducer.communication
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(MyCommunicationPreference);




// WEBPACK FOOTER //
// ./src/components/Inc/MyCommunicationPreference.js